import styled                      from 'styled-components';
import { menuTagBorderColor } from "Public/css/colors";
export default styled.span `
  a {
      color: ${menuTagBorderColor};
  }
`;